import React from "react";
import AddButton from "../../Component/UI/AddButton";

export default function RemoveTeamMember({ onClose, onSubmit }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        {/* Title */}
        <h2 className="text-lg font-semibold text-gray-800">
          Remove User
        </h2>

        {/* Message */}
        <p className="mt-3 text-sm text-gray-600">
          Are you sure you want to remove this user from the team?
          This action cannot be undone.
        </p>

        {/* Actions */}
        <div className="mt-6 flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-md border text-gray-700 hover:bg-gray-100 transition"
          >
            Cancel
          </button>

          <AddButton
            title="Remove"
            onClick={onSubmit}
            className="bg-red-600 text-white px-6 hover:bg-red-700"
          />
        </div>
      </div>
    </div>
  );
}
